export function StatusDot({ color, size = 8 }) {
  return <span style={{ width: size, height: size, background: color, borderRadius: "50%", display: "inline-block" }} />;
}
